import React from 'react';
import { formatMoney, useOrderStore } from '@sky-tv-group/shared';
import { useTotalResponse } from '@sky-tv-group/shared/src/types';

interface Props {
  totals: useTotalResponse;
  handleNext: () => void;
  handleBack: () => void;
}

export const StickyControlPanel = ({ totals, handleNext, handleBack }: Props) => {
  const { isOrderPending } = useOrderStore();
  return (
    <div className=" border lg:sticky hidden lg:block " style={{ top: '60px' }}>
      {/* <h4
        className="text-left bg-primary-white px-4 py-10 hidden lg:flex items-center justify-between sky-text-blue"
        style={{ color: '#0057ff' }}>
        <span className="sky-h4-black">Your Package</span>
        <span className="sky-h4-bold">{formatMoney(totals.monthlyPriceWithoutOffer ?? 0)}/mth</span>
      </h4> */}
     <div className=" hidden p-4 padding_box gap-2 lg:flex flex-col items-start">
            {/* with offer */}
            <div className="flex flex-col items-start p-0 h-34px gap-2">
              <div className="flex flex-row items-center justify-end p-0 h-22px">
                <div className="flex flex-row items-start padding_left_10 w-148px h-22px">
                  <span className="sky-h5-black items-center" style={{ color: '#0057ff' }}>
                    Monthly charge
                  </span>
                </div>
                <div className="flex flex-row items-end w-102px h-22px">
                  <span className="sky-h7-reg items-center text-center" style={{ color: '#0057ff' }}>
                    {formatMoney(totals.monthlyPriceWithOffer)}/mth
                  </span>
                </div>
              </div>
              <div className="flex flex-row justify-end items-center p-0 h-3">
                {/* <span className="sky-sub" style={{ marginTop: '-5%' }}>
                  With offer applied
                </span> */}
                <span className="sky-sub">
                With offer applied. After offer ends, standard pricing will apply.
                </span>
              </div>
            </div>
      </div>

      <div className="bg-gray-medium p-4 border-t border-b border-gray text-md ">
      <div className="flex justify-between">
        <div className="font-skyBold text-neutral-matte-black">Your First Bill Estimate</div>
        <div>
          <strong>{formatMoney(totals.priceYouPayToday + totals.monthlyPriceWithOffer)}</strong>
          </div>
      </div>
      <div className="text-sm mt-1">Your first invoice will include the current month and the following month's charges.</div>
      </div>

      {/* <div className="flex justify-between bg-gray-medium p-4 text-md border-t border-b border-gray font-skyBold">
        <div className=" text-neutral-matte-black">Your First Bill Estimate</div>
        <div>
          <strong>{formatMoney(totals.priceYouPayToday + totals.monthlyPriceWithOffer)}</strong>
        </div>
      </div> */}
      <div className="flex flex-row shadow-md lg:flex-row 2xl:flex-row justify-between sky-bg-neutral-off-white gap-3 p-4">
        <button
          data-testid="next-to-checkout-button"
          className="lg:w-full sky-button sky-button--primary-light mx-0 px-6"
          style={{
            minWidth: 'unset',
            backgroundColor: isOrderPending ? '#cccc' : '#0057FF',
            borderColor: isOrderPending ? '#cccc' : '#0057FF',
          }}
          onClick={handleNext}
          disabled={isOrderPending}>
          Next: About You
        </button>
      </div>
    </div>
  );
};
